import styled from 'styled-components/macro';
import { XL } from '@zendeskgarden/react-typography';
import { variables } from 'theme/variables';
import PublicPage from 'components/PublicPages/PublicPage';

const {
  spacing,
  custom_border_grey: customBorderGrey,
  media_lg: mediaLg,
  media_md: mediaMd,
} = variables;

export const CategoriesWrapper = styled(PublicPage)`
  @media ${mediaMd} {
    padding: 0 ${spacing};
  }
`;

export const CategoriesSectionHeader = styled(XL)`
  font-size: 26px;
  margin-top: -5px;
  margin-bottom: ${spacing};
`;

export const Filters = styled('div')`
  display: none;
  @media ${mediaLg} {
    display: block;
  }
`;

export const Content = styled('div')`
  max-width: 100%;
`;

export const CategoriesSection = styled('div')``;

export const CategoriesSectionInner = styled('div')`
  .filter-wrapper.od {
    padding-left: 0 !important;
  }
  .filter-wrapper.brand {
    padding-right: 0 !important;
  }
`;

export const CategoriesWrapperInner = styled('div')`
  padding: 30px 25px 0;
  display: flex;
  margin-bottom: 40px;
  & > div {
    flex: 1;
  }
  .accordian-header {
    color: #76899e;
  }
`;

export const CategoryItem = styled('div')`
  width: 100%;
  a {
    display: block;
    padding: ${spacing};
    background: #fff;
    width: 100%;
    margin-right: 10px;
    margin-bottom: 10px;
    border: 1px solid ${customBorderGrey};
    ${(props) =>
      props.active
        ? `
      &:hover, &:focus  {
        
      }
    `
        : ''};
  }
`;

export const FilterWrapper = styled('div')`
  border: 1px solid ${customBorderGrey};
  border-radius: 6px;
  margin-bottom: ${spacing};
  background: #fff;
  .item-selection-filters {
    background: transparent;
  }
  .filter-title {
    border-radius: 6px;
    line-height: 20px;
    font-size: 14px;
    direction: ltr;
    color: #3e3e3e;
  }
`;
